<script setup>
import { useSalidaStore } from '@/store/useSalidaStore';
import Dropdown from 'primevue/dropdown';
import { computed, defineEmits, defineProps } from 'vue';

const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
  modelValue: String,
  dropdown: {
    type: Boolean,
    default: false
  }
});

const salida = useSalidaStore();

const val = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value)
})
</script>
<template>
  <div>
    <div v-if="!props.dropdown" class="p-fluid">
      <div class="pb-2">
        Conductores de salidas:
      </div>
      <div v-for="item in salida.conductores" :key="item.id" class="flex gap-2 mb-1">
        <InputText v-model="item.name" class="flex-1" />
        <Button
          icon="pi pi-trash"
          outlined
          severity="danger"
          @click="salida.conductores = salida.conductores.filter(c => c.id !== item.id)"
        />
      </div>
      <Button
        icon="pi pi-plus"
        label="Agregar conductor"
        outlined
        class="mt-1 w-full"
        @click="salida.conductores.push({ id: crypto.randomUUID(), name: '' })"
      />
    </div>
    <div v-else class="p-fluid">
      <div class="pb-2">
        Conductor:
      </div>
      <Dropdown
        filter
        v-model="val"
        :options="salida.conductores.slice().sort((a, b) => a.name.localeCompare(b.name))"
        option-label="name"
        option-value="id"
        placeholder="Seleccione Conductor"
        class="w-full"
      />
    </div>
  </div>
</template>
